export const AADSTS_CODE_REGEX = /^AADSTS(\d+):\s+(.+?)\s+Trace ID:/;
